import { FC } from 'react';
import { simplifyFileNames } from '../uploadInvoice/tools';

interface FileItem {
  fileName?: string;
  status?: string;
  invoiceFileProcessingId?: string;
  dataPipelineProcessingId?: string;
  invoiceDetail?: {
    status?: string;
  };
}

interface FileListProps {
  files: FileItem[];
  hasMultipleFiles: boolean;
  isOtherSectionStatus?: boolean;
  renderStatusChip: (file: any, size?: 'small' | 'medium') => React.ReactNode;
}

/**
 * Shared component to render file list or single file with status chips
 * Used by both notification and upload UploadStatusItem components
 */
export const FileList: FC<FileListProps> = ({ files, hasMultipleFiles, isOtherSectionStatus = false, renderStatusChip }) => {
  const primaryFile = files[0];

  if (hasMultipleFiles) {
    return (
      <div className='flex flex-col gap-2'>
        {files.map((file, index) => {
          const fileStatus = file.status || file.invoiceDetail?.status;
          const fileKey = file.invoiceFileProcessingId || file.dataPipelineProcessingId || index;
          return (
            <div key={fileKey} className='flex items-center gap-x-8'>
              <h3 className='text-12 xl:text-14 select-text cursor-text'>{simplifyFileNames(file.fileName)}</h3>
              {/* Only show DUPLICATE status chip for each file if applicable */}
              {fileStatus === 'DUPLICATE' && renderStatusChip(file.invoiceDetail || file, 'small')}
            </div>
          );
        })}
      </div>
    );
  }

  const primaryFileStatus = primaryFile?.status || primaryFile?.invoiceDetail?.status;
  return (
    <div className={`flex items-center gap-x-8 ${isOtherSectionStatus ? 'justify-between' : ''}`}>
      <h3 className='text-12 xl:text-14 select-text cursor-text'>{simplifyFileNames(primaryFile?.fileName || '')}</h3>
      {/* Only show DUPLICATE status chip here, all other statuses are shown on the right */}
      {primaryFileStatus === 'DUPLICATE' && renderStatusChip(primaryFile?.invoiceDetail || primaryFile, 'small')}
    </div>
  );
};
